/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { useState, useEffect } from "react";
import { Grid, makeStyles, IconButton , Tooltip} from "@material-ui/core";
import { Edit, Delete, Lock, Person } from "@material-ui/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers } from "@fortawesome/pro-solid-svg-icons";
import EditGroup from "./EditGroup";
import { BoxContainer } from "../Users/ViewUser";
import MuiDialog from "../Dialog";
import { dateFormat } from "../utils";
import Actions from "../../../fluid/Actions/ActionFactory";
import SnackBar from "../../Snackbar/index";
import ErrorMessageAlert from "../../Utilities/ErrorMessageAlert";
import SecureWrapper from "../../Security/SecureWrapper";

const useStyles = makeStyles(() => ({
  container: {
    // display: "flex",
    // flexDirection: "column",
    height: "calc(100vh - 95px)",
    overflow: "hidden",
  },
  headerSec: {
    width: "100%",
    height: "40%",
  },
  boxWrapper: {
    height: "58%",
  },
  filedBox: {
    width: "49%",
    marginTop: "20px",
  },
}));

const ViewGroup = ({
  selectedData,
  isTableUpdated,
  setIsTableUpdated,
  setdeleted,
}) => {
  const classes = useStyles();
  console.log("child grppp", selectedData);
  const data = selectedData;
  const [isGroupDelete, setIsGroupDelete] = useState(false);
  const [isDeleted, setIsDeleted] = useState(false);
  const [isEditGroup, setIsEditGroup] = useState(false);
  const [isEdited, setisEdited] = useState(false);
  const [error, seterror] = useState(false);
  const [errmsg, seterrmsg] = useState(null);
  useEffect(() => {
    setIsEditGroup(false);
  }, [selectedData]);
  useEffect(() => {
    if (!!data && isDeleted) {
      Actions("http_request", {
        url: "/sainapse/group/" + data.name,
        method: "delete",
      })
        .then((res) => {
          console.log("res..1", res.data);
          setIsDeleted(!isDeleted);
          setIsTableUpdated(true);
          setdeleted(true);
        })
        .catch((err) => {
          console.log("err..", err.message);
          seterror(true);
          seterrmsg(err);
        });
    }
  }, [isDeleted]);

  const handleDeleteGroup = () => {
    setIsGroupDelete(true);
  };
  const handleEditGroup = () => {
    setIsEditGroup(true);
  };
  const onClose = () => {
    setisEdited(false);
  };
  const onCloseerror = () => {
    seterror(false);
    seterrmsg(null);
  };
  return (
    <>
      <div data-testid="group">
        {isEditGroup ? (
          <EditGroup
            prevData={data}
            setIsEditGroup={setIsEditGroup}
            setisEdited={setisEdited}
            setIsTableUpdated={setIsTableUpdated}
          />
        ) : (
          <Grid container className={classes.container}>
            <Grid item className={classes.headerSec}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  // padding: "10px",
                  height: "30%",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    style={{
                      width: "80px",
                      height: "80px",

                      borderRadius: "5px",
                      marginRight: "10px",
                    }}
                  >
                    <FontAwesomeIcon
                      icon={faUsers}
                      style={{
                        width: "100%",
                        height: "100%",
                        color: "#00000059",
                      }}
                    />
                  </div>
                  <div>
                    <div
                      style={{
                        color: "#222222",
                        fontSize: "1rem",
                        fontWeight: "bold",
                      }}
                    >
                      {data?.name ? data.name : "Unkown Group"}
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    width: "25%",
                    display: "flex",
                    justifyContent: "space-evenly",
                    marginTop: "10px",
                  }}
                  >
                  <SecureWrapper
                      access_object = {{
                        operation : "/sainapse/group/{name}",
                        method : "PUT",
                        operands : [
                          {
                            attrName: "name",
                            value : data.name
                      }]
                      }}
                    >
                    <Tooltip title = "Edit">
                      <IconButton
                        fontSize="small"
                        style={{
                          display: "block",
                          color: "#3683F7",
                          cursor: "pointer",
                          width: "33.3%",
                          marginRight: "-35px",
                          background: "none",
                        }}
                        disableRipple={true}
                        onClick={handleEditGroup}
                      >
                        <Edit />
                      </IconButton>
                    </Tooltip>
                  </SecureWrapper>
                  <SecureWrapper
                      access_object = {{
                        operation : "/sainapse/group/{name}",
                        method : "DELETE",
                        operands : [
                          {
                            attrName: "name",
                            value : data.name
                      }]
                      }}
                    >
                    <Tooltip title = "Delete">
                      <IconButton
                        fontSize="small"
                        style={{
                          display: "block",
                          color: "#FF0000",
                          cursor: "pointer",
                          width: "33.3%",
                          background: "none",
                        }}
                        disableRipple={true}
                        onClick={handleDeleteGroup}
                      >
                        <Delete />
                      </IconButton>
                    </Tooltip>
                  </SecureWrapper>
                </div>
              </div>
              <div
                style={{
                  height: "70%",
                  boxShadow: "0px 3px 6px #00000029",
                  bordeRadius: "5px",
                }}
              >
                <div
                  style={{
                    height: "70%",
                    background: "#FFFFFF",
                    borderBottom: "1px solid #00000029",
                    padding: "20px",
                    color: "#707070",
                  }}
                >
                  <p>
                    {data?.description ? data?.description : "No Description"}
                  </p>
                </div>
                <div
                  style={{
                    display: "flex",
                    background: "#FFFFFF",
                    padding: "10px",
                  }}
                >
                  <div style={{ paddingRight: "60px" }}>
                    <p style={{ color: "#707070" }}>
                      Active Since <br />{" "}
                      <span style={{ color: "#3682F7" }}>
                        {dateFormat(data?.created_date)}
                      </span>
                    </p>
                  </div>
                  <div>
                    <p style={{ color: "#707070" }}>
                      Last Updated <br />
                      <span style={{ color: "#3682F7" }}>
                        {dateFormat(data?.updated_date)}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
            </Grid>

            <Grid
              container
              className={classes.boxWrapper}
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <Grid item className={classes.filedBox}>
                <BoxContainer title="Users" dataList={data?.has_users} />
              </Grid>
              <Grid item className={classes.filedBox}>
                {/* <BoxContainer title="Roles" dataList={data?.group_roles} /> */}
              </Grid>
            </Grid>

            {isGroupDelete && (
              <MuiDialog
                menu="groups"
                data={data}
                open={isGroupDelete}
                type="delete"
                title="Delete Group"
                onClose={setIsGroupDelete}
                onSuccess={setIsDeleted}
              />
            )}
          </Grid>
        )}{" "}
      </div>
      {isEdited && (
        <SnackBar
          openDialog={isEdited}
          message={"Group has been Updated successfully"}
          onclose={onClose}
          severity={"success"}
        />
      )}
      {error && (
        <ErrorMessageAlert
          open={error}
          handleClose={onCloseerror}
          errorInfo={errmsg}
        />
      )}
    </>
  );
};

export default ViewGroup;
